module.exports = __webpack_public_path__ + "img/bg_index_slogan@2x.d50b2439.png";